import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  type CoinTrendingOptions,
  type TCoinTrending,
  type TCoinToken,
} from '~/types';
import { coinAPI } from '~/api';

const getCoinTrending = createAsyncThunk(
  'coin/getTrending',
  async (options?: CoinTrendingOptions) => {
    return coinAPI.getCoinTrending(options);
  },
);

export type CoinState = {
  loading: boolean;
  data: TCoinTrending | undefined;
  items: TCoinToken[];
};

const initialState: CoinState = {
  loading: true,
  data: undefined,
  items: [],
};

export const coinSlice = createSlice({
  name: 'coin',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getCoinTrending.fulfilled, (state, action) => {
      const tokens: TCoinToken[] = action.payload.data.tokens;

      state.data = action.payload;
      state.items = [...state.items, ...tokens];

      state.loading = false;
    });
    builder.addCase(getCoinTrending.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCoinTrending.rejected, (state) => {
      state.loading = false;
    });
  },
  selectors: {
    coins: (state) => state.items,
    coinsByChain: (state) => state.data,
  },
});

export const {
  actions: coinActions,
  reducer: coinReducer,
  selectors: coinSelectors,
} = coinSlice;

export const coinThunks = {
  getCoinTrending,
};
